import _BaseAPIService from "../_BaseAPIService";

    const apiService = _BaseAPIService.instance;

const JobListingService = {

    create: async (data) => {
      const response = await apiService.post("/joblistings", data);
      return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/joblistings/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
getList: async ({ search = "", status, page = 1, pageSize = 20 } = {}) => {
  const params = new URLSearchParams({
    ...(search && { search }),
    ...(status && { status }),
    page: page.toString(),
    pageSize: pageSize.toString(),
  });

  const response = await apiService.get(
    `/joblistings?${params.toString()}`
  );

  return response.data;
},


  getDetail: async (id) => {
    const response = await apiService.get(`/joblistings/${id}`);
    return response.data;
  },

  delete: async (id) => {
    const response = await apiService.delete(`/joblistings/${id}`);
    return response.data;
  },
};

export default JobListingService;

